"use client";

import dynamic from "next/dynamic";

const ClientOnlyResourceAsset = dynamic(
  () => import("@/templates/ResourceAsset"),
  {
    ssr: false,
    loading: () => <div className="min-h-[600px]" aria-hidden="true" />,
  },
);

export default ClientOnlyResourceAsset;
